<template>
    <!--   <v-touch tag="div" @pinch="invalidPinch($event)" class="three-search" :class="{ opened: searchModalFlg }"> -->
    <div
        class="three-search"
        :class="{ opened: searchModalFlg }"
    >
        <div
            class="searchBody compare"
            :class="{result: searchState === 1}"
        >
            <!-- 検索条件表示 -->
            <v-touch
                v-if="searchState === 0"
                tag="div"
                class="searchWrapper searchForm"
                @pinch="invalidPinch($event)"
            >
                <div class="searchHeader">
                    <p v-if="searchModalType === 'compare'">
                        比較球検索
                    </p>
                    <p v-else-if="searchModalType === 'standard'">
                        基準球検索
                    </p>
                    <v-touch
                        tag="p"
                        class="closeSearchBtn"
                        @tap="closeSearchModal"
                    >
                        <span class="close">×</span>
                    </v-touch>
                </div>
                <div class="searchContents">
                    <div class="formGroup">
                        <div class="formBlock">
                            <div class="label">
                                シーズン<span class="red">（必須）</span>
                            </div>
                            <div class="selector">
                                <select
                                    v-model="year"
                                    class="selectWrapper"
                                    :class="{selected: year !== ''}"
                                    @change="changedYear"
                                >
                                    <option
                                        v-for="d in listOfYears"
                                        :key="d.value"
                                        :value="d.value"
                                    >
                                        {{ d.text }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="formBlock">
                            <div class="label">
                                所属チーム<span class="red">（必須）</span>
                            </div>
                            <div
                                class="selector"
                                :class="{disabled: formSelectTeamSelectable}"
                            >
                                <select
                                    v-model="formSelectTeam"
                                    class="selectWrapper"
                                    :class="{selected: formSelectTeam !== ''}"
                                    :disabled="formSelectTeamSelectable"
                                >
                                    <option
                                        v-for="d in sortedListOfTeams"
                                        :key="d.teamID"
                                        :value="d.teamID"
                                    >
                                        {{ d.name_short2 }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="formBlock">
                            <div class="label">
                                投手名<span class="red">（必須）</span>
                            </div>
                            <div
                                class="selector"
                                :class="{disabled: formSelectPlayerSelectable}"
                            >
                                <select
                                    v-model="formSelectPlayer"
                                    class="selectWrapper"
                                    :class="{selected: formSelectPlayer !== ''}"
                                    :disabled="formSelectPlayerSelectable"
                                    @change="checkSelectPlayer"
                                >
                                    <option value="">
                                        （未選択）
                                    </option>
                                    <option
                                        v-for="(d, key) in filteredRoster"
                                        :key="key"
                                        :value="d.identifier"
                                    >
                                        {{ d.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="formBlock">
                            <div class="label">
                                対象範囲<span class="red">（必須）</span>
                            </div>
                            <div class="datepicker">
                                <div
                                    class="datepickerWrapper"
                                    :class="{selected: formSelectDate[0] !== '' && formSelectDate[1] !== ''}"
                                    @click="dateStyle"
                                >
                                    <datepicker
                                        v-model="formSelectDate"
                                        :min="formDategameSchedule.minDate"
                                        :max="formDategameSchedule.maxDate"
                                        :range="true"
                                        :player-team="playerTeam"
                                        :input-date="formSelectDate"
                                        :game-schedule="formDategameSchedule"
                                        @no-selected-player="noSelectedPlayer"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="formBlock">
                            <div class="label">
                                球場名
                            </div>
                            <div class="selector">
                                <select
                                    v-if="Object.keys(listOfStadiums).length > 0"
                                    v-model="formSelectStadium"
                                    class="selectWrapper"
                                    :class="{selected: formSelectStadium !== ''}"
                                >
                                    <option value="">
                                        （未選択）
                                    </option>
                                    <option
                                        v-for="d in sortedListOfStadiums"
                                        :key="d"
                                        :value="d"
                                    >
                                        {{
                                            d in listOfStadiums ? listOfStadiums[d].additional.name_short : d
                                        }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <!--                        <div class="formBlock">-->
                        <!--                            <div class="label">-->
                        <!--                                試合・ブルペン-->
                        <!--                            </div>-->
                        <!--                            <div class="radio">-->
                        <!--                                <div-->
                        <!--                                    class="radioBlock"-->
                        <!--                                    :class="{selected: formSelectType === 0}"-->
                        <!--                                    @click="formSelectType = 0"-->
                        <!--                                >-->
                        <!--                                    <span class="circle" />-->
                        <!--                                    <span class="text">試合</span>-->
                        <!--                                </div>-->
                        <!--                            </div>-->
                        <!--                        </div>-->
                        <div class="formBlock">
                            <div class="button">
                                <button
                                    type="button"
                                    :disabled="isValidate"
                                    @click="getBallCount()"
                                >
                                    検索する
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </v-touch>

            <!-- 検索結果表示 -->
            <div
                v-else-if="searchState === 1"
                class="searchWrapper compare result"
            >
                <!-- ヘッダー -->
                <div class="searchHeader">
                    <p v-if="formSelectType === 0 && searchModalType === 'compare'">
                        比較球検索結果 - 試合 <span
                            class="ballNumber"
                        >{{ currentBallNumber }} / {{ allBallNumber }} 球</span>
                    </p>
                    <p v-else-if="formSelectType === 0 && searchModalType === 'standard'">
                        基準球検索結果 - 試合 <span
                            class="ballNumber"
                        >{{ currentBallNumber }} / {{ allBallNumber }} 球</span>
                    </p>
                    <p v-else-if="formSelectType === 1 && searchModalType === 'compare'">
                        比較球検索結果 - ブルペン <span
                            class="ballNumber"
                        >{{ currentBallNumber }} / {{ allBallNumber }} 球</span>
                    </p>
                    <p v-else-if="formSelectType === 1 && searchModalType === 'standard'">
                        基準球検索結果 - ブルペン
                        <span
                            class="ballNumber"
                        >{{ currentBallNumber }} / {{ allBallNumber }} 球</span>
                    </p>
                    <v-touch
                        tag="p"
                        class="closeSearchBtn"
                        @tap="completeAndUpdate()"
                    >
                        <span class="close">×</span>
                    </v-touch>
                </div>

                <!-- 選手情報 -->
                <div
                    v-if="formSelectType === 0"
                    class="searchStatus"
                >
                    <span>{{ listOfTeams[formSelectTeam].name }}</span>
                    <span>{{ listOfRosters[formSelectTeam][formSelectPlayer].name }}</span>
                    <span>{{ listOfRosters[formSelectTeam][formSelectPlayer]['additional']['uniform_number'] }}</span>
                    <span>{{ formSelectDate[0] }} - </span>
                    <span>{{ formSelectDate[1] }}</span>
                </div>
                <div
                    v-else-if="formSelectType === 1"
                    class="searchStatus"
                >
                    <span>{{ listOfTeams[formSelectTeam].name }}</span>
                    <span>{{ listOfRosters[formSelectTeam][formSelectPlayer].name }}</span>
                    <span>{{ listOfRosters[formSelectTeam][formSelectPlayer]['additional']['uniform_number'] }}</span>
                    <span>{{ formSelectDate[0] }} - </span>
                    <span>{{ formSelectDate[1] }}</span>
                </div>

                <!-- フィルター 試合検索 -->
                <div
                    v-if="formSelectType === 0"
                    class="searchFilters match"
                >
                    <ul>
                        <li>
                            <div class="selector">
                                <select
                                    v-model="filterSelectDate"
                                    class="styleLongName"
                                    :class="{selected: filterSelectDate !== ''}"
                                >
                                    <option
                                        v-if="filterSelectDate === ''"
                                        value=""
                                    >
                                        投球日
                                    </option>
                                    <option
                                        v-else
                                        value=""
                                    >
                                        （指定なし）
                                    </option>
                                    <option
                                        v-for="d in pitchingDateList"
                                        :key="d"
                                        :value="d"
                                    >
                                        {{ $d(d).format('YYYY[/]MM[/]DD') }}
                                    </option>
                                </select>
                            </div>
                        </li>
                        <li>
                            <div class="selector">
                                <select
                                    v-model="formSelectBall"
                                    class="styleLongName"
                                    :class="{selected: formSelectBall !== ''}"
                                >
                                    <option
                                        v-if="formSelectBall === ''"
                                        value=""
                                    >
                                        球種
                                    </option>
                                    <option
                                        v-else
                                        value=""
                                    >
                                        （指定なし）
                                    </option>
                                    <option
                                        v-for="d in pitchingTypeList"
                                        :key="d"
                                        :value="d"
                                    >
                                        {{ setting.typesOfBall[d].name }}
                                    </option>
                                </select>
                            </div>
                        </li>
                        <li>
                            <div class="selector">
                                <select
                                    v-model="filterSelectHittype"
                                    class="styleLongName"
                                    :class="{selected: filterSelectHittype !== ''}"
                                >
                                    <option
                                        v-if="filterSelectHittype === ''"
                                        value=""
                                    >
                                        打球
                                    </option>
                                    <option
                                        v-else
                                        value=""
                                    >
                                        （指定なし）
                                    </option>
                                    <option
                                        v-for="d in pitchingHitTypeList"
                                        :key="d"
                                        :value="d"
                                    >
                                        {{ setting.typesOfHitType[d].name }}
                                    </option>
                                </select>
                            </div>
                        </li>
                        <li>
                            <div class="selector">
                                <select
                                    v-model="filterSelectResult"
                                    class="styleLongName"
                                    :class="{selected: filterSelectResult !== ''}"
                                >
                                    <option
                                        v-if="filterSelectResult === ''"
                                        value=""
                                    >
                                        判定結果
                                    </option>
                                    <option
                                        v-else
                                        value=""
                                    >
                                        （指定なし）
                                    </option>
                                    <option
                                        v-for="d in pitchingResultList"
                                        :key="d.id"
                                        :value="d"
                                    >
                                        {{ pitchingDefaultResultList[d].name }}
                                    </option>
                                </select>
                            </div>
                        </li>
                        <li>
                            <div class="selector">
                                <select
                                    v-model="filterSelectVsTeam"
                                    class="styleLongName"
                                    :class="{selected: filterSelectVsTeam !== ''}"
                                >
                                    <option
                                        v-if="filterSelectVsTeam === ''"
                                        value=""
                                    >
                                        打者チーム
                                    </option>
                                    <option
                                        v-else
                                        value=""
                                    >
                                        （指定なし）
                                    </option>
                                    <option
                                        v-for="d in pitchingVsTeamList"
                                        :key="d.id"
                                        :value="d"
                                    >
                                        {{ listOfTeamsLS[d].name_short2 }}
                                    </option>
                                </select>
                            </div>
                        </li>
                        <li>
                            <div class="selector">
                                <select
                                    v-model="filterSelectVsBatter"
                                    class="styleLongName"
                                    :disabled="filterSelectVsTeam === ''"
                                    :class="{selectDisabled: filterSelectVsTeam === ''}"
                                >
                                    <option
                                        v-if="filterSelectVsBatter === ''"
                                        value=""
                                    >
                                        打者名
                                    </option>
                                    <option
                                        v-else
                                        value=""
                                    >
                                        （指定なし）
                                    </option>
                                    <option
                                        v-for="d in pitchingVsBatterList"
                                        :key="d.id"
                                        :value="d.id"
                                    >
                                        {{ d.name }}
                                    </option>
                                </select>
                            </div>
                        </li>
                        <li>
                            <div class="selector">
                                <select
                                    v-model="filterSelectAtBat"
                                    :class="{selected: filterSelectAtBat !== ''}"
                                >
                                    <option
                                        v-if="filterSelectAtBat === ''"
                                        value=""
                                    >
                                        打席
                                    </option>
                                    <option
                                        v-else
                                        value=""
                                    >
                                        （指定なし）
                                    </option>
                                    <option
                                        v-for="d in pitchingVsAtBatList"
                                        :key="d"
                                        :value="d"
                                    >
                                        <template v-if="d === '-'">
                                            -（未計算）
                                        </template>
                                        <template v-else>
                                            第{{ d }}打席
                                        </template>
                                    </option>
                                </select>
                            </div>
                        </li>
                    </ul>
                </div>

                <!-- フィルター ブルペン検索 -->
                <div
                    v-else-if="formSelectType === 1"
                    class="searchFilters bullpen"
                >
                    <ul>
                        <li>
                            <div class="selector">
                                <select
                                    v-model="formSelectBall"
                                    :class="{selected: formSelectBall !== ''}"
                                >
                                    <option
                                        v-if="formSelectBall === ''"
                                        value=""
                                    >
                                        球種
                                    </option>
                                    <option
                                        v-else
                                        value=""
                                    >
                                        （指定なし）
                                    </option>
                                    <option
                                        v-for="d in pitchingTypeList"
                                        :key="d"
                                        :value="d"
                                    >
                                        {{ setting.typesOfBall[d].name }}
                                    </option>
                                </select>
                            </div>
                        </li>
                    </ul>
                </div>

                <!-- 結果表　試合 -->
                <div
                    v-if="formSelectType === 0"
                    class="searchContents match"
                >
                    <!-- thead 試合 -->
                    <table class="tableHeader">
                        <tr>
                            <th>投球日</th>
                            <th>球種</th>
                            <th>打球</th>
                            <th>判定結果</th>
                            <th>打者チーム</th>
                            <th>打者名</th>
                            <th>打席</th>
                            <th />
                        </tr>
                    </table>

                    <!-- tbody 試合 -->
                    <div class="tableBodyWrapper">
                        <table
                            v-if="filteredBalls.length > 0"
                            class="tableBody"
                        >
                            <!-- <tr v-for="d in compareFilter(ballsOfCompare)"> -->
                            <tr
                                v-for="d in filteredBalls"
                                :key="d.id"
                            >
                                <td>{{ $d(d.data.Date).format("YYYY/MM/DD") }}</td>
                                <td>{{ d.data.TaggedPitchType }}</td>
                                <td>{{ d.data.HitType.name }}</td>
                                <td>{{ d.data.result.name }}</td>
                                <td>{{ d.data.BatterTeamName }}</td>
                                <td>{{ d.data.BatterName }}</td>
                                <td>{{ d.data.AtBat }}</td>
                                <td>
                                    <button
                                        v-if="savedBasllsId.indexOf(d.id) !== -1 && searchModalType === 'compare'"
                                        class="compareAdd added"
                                        @click="addCompareBall(d)"
                                    >
                                        追加済
                                    </button>
                                    <button
                                        v-else-if="savedStandardBasllsId.indexOf(d.id) !== -1 && searchModalType === 'standard'"
                                        class="compareAdd added"
                                        @click="addStandardBall(d)"
                                    >
                                        選択済
                                    </button>
                                    <button
                                        v-else
                                        class="compareAdd"
                                        @click="searchModalType === 'compare' ? addCompareBall(d) : addStandardBall(d)"
                                    >
                                        {{ searchModalType === 'compare' ? '追加' : '選択' }}
                                    </button>
                                </td>
                            </tr>
                        </table>
                        <div
                            v-else
                            class="noData"
                        >
                            <p>条件に合う投球データがありません</p>
                        </div>
                    </div>
                </div>

                <!-- 結果表　ブルペン -->
                <div
                    v-if="formSelectType === 1"
                    class="searchContents bullpen"
                >
                    <!-- thead ブルペン -->
                    <table class="tableHeader">
                        <tr>
                            <th
                                rowspan="2"
                                @click="changeCompareSortNumber(0)"
                            >
                                <span>球数</span> <span
                                    class="icon-arrow-down"
                                />
                            </th>
                            <th rowspan="2">
                                球種
                            </th>
                            <th colspan="2">
                                ボールスピード
                            </th>
                            <th colspan="3">
                                ボールスピン
                            </th>
                            <th colspan="2">
                                ボール変化量
                            </th>
                            <th colspan="2">
                                リリース
                            </th>
                            <th rowspan="2" />
                        </tr>
                        <tr>
                            <th @click="changeCompareSortNumber(1)">
                                <span>球速(km/h)</span> <span
                                    class="icon-arrow-down"
                                />
                            </th>
                            <th @click="changeCompareSortNumber(2)">
                                <span>球速比(％)</span> <span
                                    class="icon-arrow-down"
                                />
                            </th>
                            <th @click="changeCompareSortNumber(3)">
                                <span>回転速度(rpm)</span> <span
                                    class="icon-arrow-down"
                                />
                            </th>
                            <th @click="changeCompareSortNumber(4)">
                                <span>α(°)</span> <span
                                    class="icon-arrow-down"
                                />
                            </th>
                            <th @click="changeCompareSortNumber(5)">
                                <span>有効回転速度(rpm)</span> <span
                                    class="icon-arrow-down"
                                />
                            </th>
                            <th @click="changeCompareSortNumber(5)">
                                <span>縦(cm)</span> <span
                                    class="icon-arrow-down"
                                />
                            </th>
                            <th @click="changeCompareSortNumber(7)">
                                <span>横(cm)</span> <span
                                    class="icon-arrow-down"
                                />
                            </th>
                            <th @click="changeCompareSortNumber(8)">
                                <span>高(cm)</span> <span
                                    class="icon-arrow-down"
                                />
                            </th>
                            <th @click="changeCompareSortNumber(9)">
                                <span>横(cm)</span> <span
                                    class="icon-arrow-down"
                                />
                            </th>
                        </tr>
                    </table>

                    <!-- tbody ブルペン -->
                    <div class="tableBodyWrapper">
                        <table class="tableBody">
                            <tr
                                v-for="d in filteredBalls"
                                :key="d.id"
                            >
                                <td>{{ d.data.pitchno }}</td>
                                <td>{{ d.data.TaggedPitchType }}</td>
                                <td>{{ d.data.RelSpeed }}km/h</td>
                                <td>{{ d.data.RelSpeed_Per }}％</td>
                                <td>{{ d.data.SpinRate }}rpm</td>
                                <td>{{ d.data.Rifle }}°</td>
                                <td>{{ d.data.w_sin_a }}rpm</td>
                                <td>{{ d.data.InducedVertBreak }}cm</td>
                                <td>{{ d.data.HorzBreak }}cm</td>
                                <td>{{ d.data.RelHeight }}cm</td>
                                <td>{{ d.data.RelSide }}cm</td>
                                <td>
                                    <button
                                        v-if="savedBasllsId.indexOf(d.id) !== -1 && searchModalType === 'compare'"
                                        class="compareAdd added"
                                        @click="addCompareBall(d)"
                                    >
                                        追加済
                                    </button>
                                    <button
                                        v-else-if="savedStandardBasllsId.indexOf(d.id) !== -1 && searchModalType === 'standard'"
                                        class="compareAdd added"
                                        @click="addStandardBall(d)"
                                    >
                                        選択済
                                    </button>
                                    <button
                                        v-else
                                        class="compareAdd"
                                        @click="searchModalType === 'compare' ? addCompareBall(d) : addStandardBall(d)"
                                    >
                                        {{ searchModalType === 'compare' ? '追加' : '選択' }}
                                    </button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--   </v-touch> -->
</template>

<script>
import Common3dSearch from '@/components_common/3d/Search.vue'
import datepicker from '@/components/utility/Datepicker3dSearch'

export default {
    name: 'ThreeSearch',
    components: {
        datepicker
    },
    mixins: [Common3dSearch],
    methods: {
        // datepicker-css適用
        dateStyle () {
            const btnDecide = document.getElementById('btnDecide')
            btnDecide.style.fontSize = '16px'
            // 曜日文字サイズ変更
            const listItems = document.querySelectorAll('.type-date .weeks li')
            listItems.forEach(item => {
                item.style.fontSize = '16px'
            })
        }
    }
}
</script>

<style scoped>
.three-search {
    position: absolute;
    top: 55px;
    transition: .2s;
    left: -470px;
    z-index: 2;
    height: calc(100% - 55px);
}

.three-search.opened {
    left: 0;
}

.searchBody {
    background: rgba(34, 34, 34, 0.95);
    width: 470px;
    height: 100%;
    color: #fff;
    overflow: hidden;
}

.searchBody .searchWrapper {
    width: 440px;
    height: 673px;
    margin: 0 auto;
}

.searchBody .searchWrapper.result {
    width: 939px;
    height: 673px;
}

.searchBody .searchWrapper .searchHeader {
    width: 440px;
    height: 15px;
    position: relative;
    /*margin-top: 20px;*/
    box-sizing: border-box;
}

.searchBody .searchWrapper.searchForm .searchHeader {
    margin-top: 20px;
}

.searchBody .searchWrapper .searchHeader p {
    font-size: 15px;
}

.searchBody .searchWrapper .searchHeader p.closeSearchBtn {
    width: 24px;
    height: 24px;
    position: absolute;
    top: -5px;
    right: 0;
}

.searchBody .searchWrapper .searchHeader p .ballNumber {
    padding-left: 15px;
}

.searchBody .searchWrapper .searchHeader p.closeSearchBtn .close {
    font-size: 24px;
}

.searchBody .searchWrapper .searchStatus {
    width: 919px;
    height: 13px;
    position: relative;
    margin-top: 20px;
    box-sizing: border-box;
}

.searchBody .searchWrapper .searchStatus span {
    font-size: 13px;
    padding-right: 30px;
}

.searchBody .searchWrapper .searchStatus span:nth-child(4) {
    padding-right: 0;
}

.searchBody .searchWrapper .searchStatus span:last-child {
    padding-right: 0;
}

.searchBody .searchWrapper .searchContents {
    width: 320px;
    /*  margin: 79px auto 0;*/
    margin: 31.5px auto 0;
}

.searchBody .searchWrapper .searchContents .formGroup {
}

.searchBody .searchWrapper .searchContents .formGroup .formBlock {
    margin-bottom: 25px;
}

.searchBody .searchWrapper .searchContents .formGroup .formBlock.last {
    margin-bottom: 20px;
}

.searchBody .searchWrapper .searchContents .formGroup .formBlock .label {
    font-size: 12px;
    margin-bottom: 10px;
}

.searchBody .searchWrapper .searchContents .formGroup .formBlock .label span.red {
    font-size: 10px;
    color: #ff0000;
}

.searchBody .searchWrapper .searchContents .formGroup .formBlock .selector {
    width: 320px;
    height: 30px;
    background: #555555;
    position: relative;
}

.searchBody .searchWrapper .searchContents .formGroup .formBlock .selector:before {
    content: "▼";
    display: block;
    position: absolute;
    bottom: 12px;
    right: 14px;
    width: 8px;
    height: 8px;
    z-index: 1;
    margin: auto;
    color: #bbbbbb;
    transform: scale(0.8);
    -webkit-transform: scale(0.8);
    /*  border: solid #888;
      border-width: 0 2px 2px 0;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
    */
}

.searchBody .searchWrapper .searchContents .formGroup .formBlock .selector.disabled {
    background: #2a2a2a;
}

.searchBody .searchWrapper .searchContents .formGroup .formBlock .selector.disabled:before {
    display: none;
}

.searchBody .searchWrapper .searchContents .formGroup .formBlock .selector select {
    width: 320px;
    height: 30px;
    position: relative;
    z-index: 2;
    outline: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    padding: 3px 40px 3px 10px;
    border: none;
    /*  border-radius: 4px;
      border: 1px solid #828282;*/
    background: transparent;
    font-size: 1.5rem;
    color: #999999;
}

.searchBody .searchWrapper .searchContents .formGroup .formBlock .selector select.selected {
    color: #ffffff;
}

.searchBody .searchWrapper .searchContents .formGroup .formBlock .selector select option {
    color: #000000;
}

.searchBody .searchWrapper .searchContents .formGroup .formBlock .selector.half,
.searchBody .searchWrapper .searchContents .formGroup .formBlock .selector.half select {
    height: 50px;
}

.searchBody .searchWrapper .searchContents .formGroup .formBlock .radio {
    width: 320px;
    height: 20px;
    position: relative;
}

.searchBody .searchWrapper .searchContents .formGroup .formBlock .radio .radioBlock .circle {
    width: 20px;
    height: 20px;
    display: block;
    float: left;
    border-radius: 10px;
    background: #555555;
    position: relative;
}

.searchBody .searchWrapper .searchContents .formGroup .formBlock .radio .radioBlock.selected .circle:before {
    content: "";
    width: 12px;
    height: 12px;
    display: block;
    border-radius: 10px;
    background: #ffffff;
    position: absolute;
    top: 4px;
    left: 4px;
}

.searchBody .searchWrapper .searchContents .formGroup .formBlock .radio .radioBlock .text {
    width: 60px;
    height: 20px;
    display: block;
    float: left;
    padding-top: 4px;
    padding-left: 10px;
    font-size: 12px;
}

.searchBody .searchWrapper .searchContents .formGroup .formBlock .datepicker .datepickerWrapper {
    color: #999999;
}

.searchBody .searchWrapper .searchContents .formGroup .formBlock .datepicker .datepickerWrapper.selected {
    color: #ffffff;
}

.searchBody .searchWrapper .searchContents .formGroup .formBlock .button {

}

.searchBody .searchWrapper .searchContents .formGroup .formBlock .button button {
    width: 320px;
    height: 30px;
    background: #444444;
    appearance: none;
    -webkit-appearance: none;
    border: none;
    font-size: 12px;
    color: #ffffff;
}

.searchBody .searchWrapper .searchContents .formGroup .formBlock .button button[disabled="disabled"] {
    color: #999999;
    background: #333333;
}

/* search result */
.searchBody.result {
    width: 939px;
}

.searchBody .searchWrapper.result {
    width: 919px;
    height: 100%;
    padding-top: 20px;
}

.searchBody .searchWrapper.result .searchHeader {
    width: 919px;
}

.searchBody .searchWrapper.result .searchContents {
    width: 919px;
    height: calc(100% - 117px);
    margin: 0 auto;
}

.searchBody .searchWrapper.result .searchContents table {
    width: 919px;
    box-sizing: border-box;
}

.searchBody .searchWrapper.result .searchContents table tr {
}

.searchBody .searchWrapper.result .searchContents table tr td {
    font-size: 1rem;
    text-align: left;
}

/* table header */
.searchBody .searchWrapper.result .searchContents table.tableHeader {
    height: 90px;
    border-top: 1px solid #666666;
    border-bottom: 1px solid #666666;
    margin-top: 20px;
}

.searchBody .searchWrapper.result .searchContents table.tableHeader tr {

}

.searchBody .searchWrapper.result .searchContents table.tableHeader tr th {
    font-size: 1rem;
    text-align: left;
    vertical-align: middle;
}

/* table header upper */
.searchBody .searchWrapper.result .searchContents table.tableHeader tr:nth-child(1) th:nth-child(1) {
    position: relative;
    width: 50px;
}

.searchBody .searchWrapper.result .searchContents table.tableHeader tr:nth-child(1) th:nth-child(2) {
    width: 100px;
}

.searchBody .searchWrapper.result .searchContents table.tableHeader tr:nth-child(1) th:nth-child(3) {
    width: 150px;
}

.searchBody .searchWrapper.result .searchContents table.tableHeader tr:nth-child(1) th:nth-child(4) {
    width: 215px;
}

.searchBody .searchWrapper.result .searchContents table.tableHeader tr:nth-child(1) th:nth-child(5) {
    width: 150px;
}

.searchBody .searchWrapper.result .searchContents table.tableHeader tr:nth-child(1) th:nth-child(6) {
    width: 150px;
}

.searchBody .searchWrapper.result .searchContents table.tableHeader tr:nth-child(1) th:nth-child(7) {
    width: 91px;
}

/* table header lower */
.searchBody .searchWrapper.result .searchContents table.tableHeader tr:nth-child(2) th:nth-child(1),
.searchBody .searchWrapper.result .searchContents table.tableHeader tr:nth-child(2) th:nth-child(2),
.searchBody .searchWrapper.result .searchContents table.tableHeader tr:nth-child(2) th:nth-child(3),
.searchBody .searchWrapper.result .searchContents table.tableHeader tr:nth-child(2) th:nth-child(6),
.searchBody .searchWrapper.result .searchContents table.tableHeader tr:nth-child(2) th:nth-child(7),
.searchBody .searchWrapper.result .searchContents table.tableHeader tr:nth-child(2) th:nth-child(8),
.searchBody .searchWrapper.result .searchContents table.tableHeader tr:nth-child(2) th:nth-child(9) {
    position: relative;
    padding-bottom: 15px;
    width: 75px;
}

.searchBody .searchWrapper.result .searchContents table.tableHeader tr:nth-child(2) th:nth-child(4) {
    position: relative;
    padding-bottom: 15px;
    width: 40px;
}

.searchBody .searchWrapper.result .searchContents table.tableHeader tr:nth-child(2) th:nth-child(5) {
    position: relative;
    padding-bottom: 15px;
    width: 100px;
}

.searchBody .searchWrapper.result .searchContents table.tableHeader tr:nth-child(2) th span:nth-child(1) {
    float: left;
}

.searchBody .searchWrapper.result .searchContents table.tableHeader tr:nth-child(2) th span:nth-child(2) {
    float: left;
    padding-left: 2px;
}

/* table body */
.searchBody .searchWrapper.result .searchContents .tableBodyWrapper {
    position: relative;
    width: 919px;
    height: 400px;
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
}

.searchBody .searchWrapper.result .searchContents .tableBodyWrapper table.tableBody {
}

/* table body upper */
.searchBody .searchWrapper.result .searchContents .tableBodyWrapper table.tableBody tr td {
    height: 45px;
    border-top: 1px solid #666666;
    text-align: left;
    vertical-align: middle;
    box-sizing: border-box;
}

.searchBody .searchWrapper.result .searchContents .tableBodyWrapper table.tableBody tr:nth-child(1) td {
    border: none;
}

.searchBody .searchWrapper.result .searchContents .tableBodyWrapper table.tableBody tr td:nth-child(1) {
    width: 50px;
}

.searchBody .searchWrapper.result .searchContents .tableBodyWrapper table.tableBody tr td:nth-child(2) {
    width: 100px;
}

.searchBody .searchWrapper.result .searchContents .tableBodyWrapper table.tableBody tr td:nth-child(3),
.searchBody .searchWrapper.result .searchContents .tableBodyWrapper table.tableBody tr td:nth-child(4),
.searchBody .searchWrapper.result .searchContents .tableBodyWrapper table.tableBody tr td:nth-child(5),
.searchBody .searchWrapper.result .searchContents .tableBodyWrapper table.tableBody tr td:nth-child(8),
.searchBody .searchWrapper.result .searchContents .tableBodyWrapper table.tableBody tr td:nth-child(9),
.searchBody .searchWrapper.result .searchContents .tableBodyWrapper table.tableBody tr td:nth-child(10),
.searchBody .searchWrapper.result .searchContents .tableBodyWrapper table.tableBody tr td:nth-child(11) {
    width: 75px;
}

.searchBody .searchWrapper.result .searchContents .tableBodyWrapper table.tableBody tr td:nth-child(6) {
    width: 40px;
}

.searchBody .searchWrapper.result .searchContents .tableBodyWrapper table.tableBody tr td:nth-child(7) {
    width: 100px;
}

.searchBody .searchWrapper.result .searchContents .tableBodyWrapper table.tableBody tr td:nth-child(12) {
    width: 91px;
}

.searchBody .searchWrapper.result .searchContents .tableBodyWrapper table.tableBody tr td .compareAdd {
    width: 70px;
    height: 30px;
    background: #555555;
    color: #ffffff;
    appearance: none;
    -webkit-appearance: none;
    border: none;
}

.searchBody .searchWrapper.result .searchContents .tableBodyWrapper table.tableBody tr td .compareAdd.added {
    background: #333333;
    color: #dddddd;
    border: 1px solid #999;
}

.searchBody .searchWrapper.result .searchContents .tableBodyWrapper table.tableBody tr td .compareAdd.added span.icon-check {
    color: #00ff00;
}

.searchBody .searchWrapper.result .searchContents .tableBodyWrapper .noData {
    position: absolute;
    left: 0;
    top: 45%;
    width: 100%;
    font-size: 1.4rem;
    text-align: center;
    color: #fff;
}

/* search filter */
.searchBody .searchWrapper .searchFilters {
    width: 919px;
    height: 30px;
    position: relative;
    margin-top: 20px;
    box-sizing: border-box;
}

.searchBody .searchWrapper .searchFilters ul {
    width: 919px;
    height: 30px;
}

.searchBody .searchWrapper .searchFilters ul li {
    float: left;
    margin-left: 10px;
}

.searchBody .searchWrapper .searchFilters ul li:nth-child(1) {
    margin-left: 0;
}

.searchBody .searchWrapper .searchFilters ul li .selector {
    width: 120px;
    height: 30px;
    background: #555555;
    position: relative;
}

.searchBody .searchWrapper .searchFilters ul li .selector:before {
    content: "▼";
    display: block;
    position: absolute;
    bottom: 12px;
    right: 14px;
    width: 8px;
    height: 8px;
    z-index: 1;
    margin: auto;
    color: #bbbbbb;
    transform: scale(0.8);
    -webkit-transform: scale(0.8);
}

.searchBody .searchWrapper .searchFilters ul li .selector select {
    width: 160px;
    height: 30px;
    position: relative;
    z-index: 2;
    outline: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    padding: 1px 40px 3px 10px;
    border: none;
    /*  border-radius: 4px;
      border: 1px solid #828282;*/
    background: transparent;
    font-size: 12px;
    color: #ffffff;
}

.searchBody .searchWrapper .searchFilters ul li .selector select.selected {
    color: #ffffff;
}

.searchBody .searchWrapper .searchFilters ul li .selector select.selectDisabled {
    color: #999999;
}

.searchBody .searchWrapper .searchFilters ul li .selector select option {
    color: #000000;
}

.searchBody .searchWrapper .searchFilters ul li .selector.half,
.searchBody .searchWrapper .searchFilters ul li .selector.half select {
    height: 50px;
}

.searchBody .searchWrapper.compare.result .searchFilters ul li {
    width: 160px;
}

.searchBody .searchWrapper.compare.result .searchFilters ul li .selector {
    width: 160px;
    overflow: hidden;
}

/* compare result 試合 */
.searchBody .searchWrapper.compare.result .searchFilters.match ul li:nth-child(1),
.searchBody .searchWrapper.compare.result .searchFilters.match ul li:nth-child(1) .selector {
    width: 98px;
}

.searchBody .searchWrapper.compare.result .searchFilters.match ul li:nth-child(1) select {
    width: 150px;
    letter-spacing: 0.1rem;
}

.searchBody .searchWrapper.compare.result .searchFilters.match ul li:nth-child(2),
.searchBody .searchWrapper.compare.result .searchFilters.match ul li:nth-child(2) .selector {
    width: 105px;
}

.searchBody .searchWrapper.compare.result .searchFilters.match ul li:nth-child(2) select {
    width: 140px;
}

.searchBody .searchWrapper.compare.result .searchFilters.match ul li:nth-child(3),
.searchBody .searchWrapper.compare.result .searchFilters.match ul li:nth-child(3) .selector {
    width: 85px;
}

.searchBody .searchWrapper.compare.result .searchFilters.match ul li:nth-child(3) select {
    width: 120px;
}

.searchBody .searchWrapper.compare.result .searchFilters.match ul li:nth-child(4),
.searchBody .searchWrapper.compare.result .searchFilters.match ul li:nth-child(4) .selector {
    width: 156px;
}

.searchBody .searchWrapper.compare.result .searchFilters.match ul li:nth-child(4) select {
    width: 225px;
}

.searchBody .searchWrapper.compare.result .searchFilters.match ul li:nth-child(5),
.searchBody .searchWrapper.compare.result .searchFilters.match ul li:nth-child(5) .selector {
    width: 182px;
}

.searchBody .searchWrapper.compare.result .searchFilters.match ul li:nth-child(5) select {
    width: 240px;
}

.searchBody .searchWrapper.compare.result .searchFilters.match ul li:nth-child(6),
.searchBody .searchWrapper.compare.result .searchFilters.match ul li:nth-child(6) .selector {
    width: 132px;
}

.searchBody .searchWrapper.compare.result .searchFilters.match ul li:nth-child(6) select {
    width: 170px;
}

.searchBody .searchWrapper.compare.result .searchFilters.match ul li:nth-child(7),
.searchBody .searchWrapper.compare.result .searchFilters.match ul li:nth-child(7) .selector {
    width: 100px;
}

.searchBody .searchWrapper.compare.result .searchFilters.match ul li:nth-child(7) select {
    font-size: 1rem;
    width: 110px;
}

.searchBody .searchWrapper.compare.result .searchFilters.match ul li .selector .styleLongName {
    /*transform-origin: top left;*/
    /*transform: scale(0.8, 1);*/
    font-size: 1rem;
}

/* table header match */
.searchBody .searchWrapper.result .searchContents table.tableHeader {
    height: 45px;
}

/* table header upper match */
.searchBody .searchWrapper.result .searchContents.match table.tableHeader tr:nth-child(1) th:nth-child(1) {
    width: 74px;
}

.searchBody .searchWrapper.result .searchContents.match table.tableHeader tr:nth-child(1) th:nth-child(2) {
    width: 80px;
}

.searchBody .searchWrapper.result .searchContents.match table.tableHeader tr:nth-child(1) th:nth-child(3) {
    width: 80px;
}

.searchBody .searchWrapper.result .searchContents.match table.tableHeader tr:nth-child(1) th:nth-child(4) {
    width: 154px;
}

.searchBody .searchWrapper.result .searchContents.match table.tableHeader tr:nth-child(1) th:nth-child(5) {
    width: auto;
}

.searchBody .searchWrapper.result .searchContents.match table.tableHeader tr:nth-child(1) th:nth-child(6) {
    width: 150px;
}

.searchBody .searchWrapper.result .searchContents.match table.tableHeader tr:nth-child(1) th:nth-child(7) {
    width: 80px;
}

.searchBody .searchWrapper.result .searchContents.match table.tableHeader tr:nth-child(1) th:nth-child(8) {
    width: 95px;
}

/* table body match */
.searchBody .searchWrapper.result .searchContents.match .tableBodyWrapper {
    width: 919px;
    height: calc(100% - 44px);
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
}

.searchBody .searchWrapper.result .searchContents.match .tableBodyWrapper table.tableBody {
}

/* table body upper match */
.searchBody .searchWrapper.result .searchContents.match .tableBodyWrapper table.tableBody tr td {
    height: 45px;
    border-top: 1px solid #666666;
    text-align: left;
    vertical-align: middle;
    box-sizing: border-box;
}

.searchBody .searchWrapper.result .searchContents.match .tableBodyWrapper table.tableBody tr:nth-child(1) td {
    border: none;
}

.searchBody .searchWrapper.result .searchContents.match .tableBodyWrapper table.tableBody tr td:nth-child(1) {
    width: 74px;
}

.searchBody .searchWrapper.result .searchContents.match .tableBodyWrapper table.tableBody tr td:nth-child(2) {
    width: 80px;
}

.searchBody .searchWrapper.result .searchContents.match .tableBodyWrapper table.tableBody tr td:nth-child(3) {
    width: 80px;
}

.searchBody .searchWrapper.result .searchContents.match .tableBodyWrapper table.tableBody tr td:nth-child(4) {
    width: 154px;
}

.searchBody .searchWrapper.result .searchContents.match .tableBodyWrapper table.tableBody tr td:nth-child(5) {
    width: auto;
}

.searchBody .searchWrapper.result .searchContents.match .tableBodyWrapper table.tableBody tr td:nth-child(6) {
    width: 150px;
}

.searchBody .searchWrapper.result .searchContents.match .tableBodyWrapper table.tableBody tr td:nth-child(7) {
    width: 80px;
}

.searchBody .searchWrapper.result .searchContents.match .tableBodyWrapper table.tableBody tr td:nth-child(8) {
    width: 95px;
}

.searchBody .searchWrapper.result .searchContents.match .tableBodyWrapper table.tableBody tr td .compareAdd {
    width: 70px;
    height: 30px;
    background: #555555;
    color: #ffffff;
    appearance: none;
    -webkit-appearance: none;
    border: none;
}

.searchBody .searchWrapper.result .searchContents.match .tableBodyWrapper table.tableBody tr td .compareAdd.added {
    background: #333333;
    color: #dddddd;
    border: 1px solid #999;
}

.searchBody .searchWrapper.result .searchContents.match .tableBodyWrapper table.tableBody tr td .compareAdd.added span.icon-check {
    color: #00ff00;
}

.icon-arrow-down {
    position: absolute;
    left: 5px;
    bottom: 5px;
}


</style>
